<template>
	<form class="form-component" @submit.prevent="saveInformation">
		<div
			class="wrapper-message"
			:class="{'open': message}">
			<img
				:src="`${$S3}checked-1.svg`"
				alt="finalizado"
				height="60"
				>
			<p class="message-text mt-3">
				<span class="bold">GRACIAS</span><br/>
				POR INSCRIBIRTE <br/>
				Y CONFIAR EN NOSOTROS
			</p>
			<p class="message-information">
				EN EL TRANSCURSO DEL DÍA <br/>NOS COMUNICAMOS CON USTED
			</p>
		</div>
		<div class="wrapper-loading" v-if="showloading">
			<div class="wrapper-opacity"></div>
			<div class="loading">
				<v-progress-circular
					:size="70"
					:width="7"
					indeterminate
					color="teal darken-1">
				</v-progress-circular>
			</div>
		</div>
		<p class="title-form ma-0 mb-3">¡Solicita tu app YA!</p>
		<v-layout wrap>
			<v-flex xs12>
				<div>
					<p class="mb-0 text-warehouse center">{{ count }} NEGOCIOS INSCRITOS</p>
				</div>
			</v-flex>
		</v-layout>
		<v-layout wrap class="wrapper-btn">
			<v-flex px-1 md6 xs12 mb-2>
				<button
					class="btn-not-available"
					type="button"
					@click="$emit('open-modal')">{{cellar.assigned}} Negocios validados</button>
			</v-flex>
			<v-flex px-1 md6 xs12 mb-2>
				<span class="btn-available">{{cellar.available}} cupos disponibles</span>
			</v-flex>
		</v-layout>
		<v-layout row wrap class="contact-form">
			<v-flex xs12>
				<input
					type="text"
					placeholder="Tu nombre"
					class="input-component"
					v-model="model.name">
			</v-flex>
			<v-flex xs12>
				<input
					type="text"
					placeholder="Nombre de tu negocio"
					class="input-component"
					v-model="model.nameWarehouse">
			</v-flex>
			<v-flex xs12>
				<input
					type="email"
					placeholder="Tu correo"
					class="input-component"
					v-model="model.email">
			</v-flex>
			<v-flex xs12>
				<v-layout>
					<v-flex x4>
						<v-select
							class="input-component"
							label="Tu país"
							v-model="model.country"
							item-text="value"
							item-value="name"
							:items="countries"
							hide-details
							single-line
						>
						<template slot="selection" slot-scope="data">
								<div>
									<img
										:src="data.item.image"
										:alt="data.item.name"
										height="20">
									<span>{{data.item.value}}</span>
								</div>
							</template>
							<template slot="item" slot-scope="data">
								<div>
									<img
										:src="data.item.image"
										:alt="data.item.name"
										height="20">
									<span>{{data.item.value}}</span>
								</div>
							</template>
						</v-select>
					</v-flex>
					<v-flex xs8 pl-2>
						<input
						type="number"
						placeholder="Tu celular"
						class="input-component mb-0"
						v-model="model.phone">
						<!-- <span
							v-if="!isPeru && this.model.phone.length > 9"
							class="text-info">
							El número de celular debe tener 9 dígitos
						</span> -->
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<v-select
					class="input-component"
					:label="caption"
					v-model="model.nameCity"
					item-text="name"
					item-value="name"
					:items="departments"
					hide-details
					autocomplete
					single-line
				></v-select>
			</v-flex>
			<v-flex xs12 mb-2 pt-2>
				<v-layout wrap>
					<v-flex xs1>
						<v-checkbox
							color="success"
							hide-details
							v-model="model.flagShareInfo"
						></v-checkbox>
					</v-flex>
					<v-flex xs11>
						<span class="font11">Estoy deacuerdo con compartir mis datos con MiBodega.</span>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<v-layout wrap>
					<v-flex xs12 pt-1>
						<span class="font11">*no incluye costo de implementación</span>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 px-2 pt-4>
				<button
					class="btn-form"
					:disabled="!disabled || loading"
					type="submit">Solicito mi app</button>
			</v-flex>
		</v-layout>
		<div class="footer-form text-xs-center">
			<p class="mb-0">Después de inscribirte te llamaremos por <br/>teléfono para validar tu cupo</p>
		</div>
	</form>
</template>
<script>

function disabled() {
	const phonePer = this.isPeru ? this.model.phone.length > 7 && this.model.phone.length < 10 :
		this.model.phone.length > 7 && this.model.phone.length < 11;
	return this.model.email && this.model.name && this.model.phone &&
		this.model.nameCity && phonePer;
}

async function saveInformation() {
	this.showloading = true;
	const body = {
		companyId: process.env.COMPANY_ID,
		data: {
			email: this.model.email,
			from: process.env.FORM_FROM,
			fullName: this.model.name,
			message: process.env.FORM_MESSAGE,
			phone: this.model.phone,
			to: process.env.FORM_TO,
			nameCity: this.model.nameCity,
			flagShareInfo: this.model.flagShareInfo,
			flagReceiveNews: this.model.flagReceiveNews,
			nameWarehouse: this.model.nameWarehouse,
			country: this.model.country,
		},
		flagMailValid: true,
		templateCode: process.env.TEMPLATE_CODE,
		sheetId: process.env.SHEET_ID,
	};
	this.loading = true;
	if (!this.isPeru && body.data.phone.length > 9) {
		if (Number(body.data.phone[0]) === 0) {
			const phoneStr = body.data.phone.toString();
			body.data.phone = phoneStr.slice(1, 10);
		}
	}
	const prefix = this.countries.findIndex(c => c.name === this.model.country);
	if (prefix > -1) {
		body.data.phone = `${this.countries[prefix].value} ${body.data.phone}`;
	}
	if (this.$route.meta.origin) {
		body.data.origin = this.$route.meta.origin;
	}
	try {
		await this.$httpNotification.post('notifications/EMAIL/public', body);
		this.sendInformation();
		this.sendInformationWsp();
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
			this.showloading = false;
		}
	}
}

async function sendInformation() {
	const body = {
		companyId: process.env.COMPANY_ID,
		data: {
			email: process.env.FORM_TO,
			from: process.env.FORM_FROM,
			fullName: this.model.name,
			message: process.env.FORM_MESSAGE,
			phone: this.model.phone,
			to: this.model.email,
			nameCity: this.model.nameCity,
			flagShareInfo: this.model.flagShareInfo,
			flagReceiveNews: this.model.flagReceiveNews,
		},
		templateCode: process.env.TEMPLATE_CONFIRM,
	};
	try {
		await this.$httpNotification.post('notifications/EMAIL/public', body);
		this.showMessage();
		this.loading = false;
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
			this.showloading = false;
			this.loading = false;
		}
	}
}

async function sendInformationWsp() {
	const body = {
		companyId: process.env.COMPANY_ID_FORM,
		data: {
			phone: `${this.prefixPhone}${this.model.phone}`,
			fields: {
				fullName: this.model.name,
			},
		},
		templateCode: process.env.TEMPLATE_WSP,
	};
	try {
		await this.$httpNotification.post('notifications/WTAPP/public', body);
	} catch (error) {
		this.showGenericError();
	}
}

function clearForm() {
	this.model = {
		name: '',
		email: '',
		phone: '',
		nameCity: '',
		flagShareInfo: true,
		flagReceiveNews: true,
		nameWarehouse: '',
		country: this.isPeru ? 'Peru' : 'Ecuador',
	};
}

function showMessage() {
	this.showloading = false;
	this.message = true;
	this.clearForm();
	setTimeout(() => { this.message = false; }, 10000);
}

function departments() {
	const country = `departments${this.model.country}`;
	this.model.nameCity = '';
	if (this.model.country === 'Peru' || this.model.country === 'Colombia' || this.model.country === 'Bolivia') {
		this.caption = 'Tu departamento';
	} else if (this.model.country === 'Ecuador') {
		this.caption = 'Tu provincia';
	} else if (this.model.country === 'Chile') {
		this.caption = 'Tu región';
	}
	return this[country];
}

function created() {
	this.model.country = this.isPeru ? 'Peru' : 'Ecuador';
	this.caption = this.isPeru ? 'Tu departamento' : 'Tu provincia';
}

function prefixPhone() {
	let prefix = '51';
	const index = this.countries.findIndex(c => c.name === this.model.country);
	if (index > -1) {
		prefix = this.countries[index].phone;
	}
	return prefix;
}

function data() {
	return {
		model: {
			name: '',
			email: '',
			phone: '',
			nameCity: '',
			flagShareInfo: true,
			flagReceiveNews: true,
			country: 'Peru',
		},
		loading: false,
		message: false,
		countries: [
			{
				id: 1,
				value: '+51',
				name: 'Peru',
				image: '/static/images/banners/peru.svg',
				phone: '51',
			},
			{
				id: 2,
				value: '+593',
				name: 'Ecuador',
				image: '/static/images/banners/ecuador.svg',
				phone: '593',
			},
			{
				id: 3,
				value: '+56',
				name: 'Chile',
				image: '/static/images/banners/chile.svg',
				phone: '56',
			},
			{
				id: 4,
				value: '+57',
				name: 'Colombia',
				image: '/static/images/banners/colombia.svg',
				phone: '57',
			},
			{
				id: 5,
				value: '+591',
				name: 'Bolivia',
				image: '/static/images/banners/bolivia.svg',
				phone: '91',
			},
		],
		departmentsPeru: [
			{ name: 'Amazonas' },
			{ name: 'Áncash' },
			{ name: 'Apurímac' },
			{ name: 'Arequipa' },
			{ name: 'Ayacucho' },
			{ name: 'Cajamarca' },
			{ name: 'Cusco' },
			{ name: 'Huancavelica' },
			{ name: 'Huánuco' },
			{ name: 'Ica' },
			{ name: 'Junín' },
			{ name: 'La Libertad' },
			{ name: 'Lambayeque' },
			{ name: 'Lima' },
			{ name: 'Loreto' },
			{ name: 'Madre de Dios' },
			{ name: 'Moquegua' },
			{ name: 'Pasco' },
			{ name: 'Piura' },
			{ name: 'Puno' },
			{ name: 'San Martín' },
			{ name: 'Tacna' },
			{ name: 'Tumbes' },
			{ name: 'Ucayali' },
		],
		departmentsEcuador: [
			{ name: 'Azuay' },
			{ name: 'Bolívar' },
			{ name: 'Cañar' },
			{ name: 'Carchi' },
			{ name: 'Chimborazo' },
			{ name: 'Cotopaxi' },
			{ name: 'El Oro' },
			{ name: 'Esmeraldas' },
			{ name: 'Galápagos' },
			{ name: 'Guayas' },
			{ name: 'Imbabura' },
			{ name: 'Loja' },
			{ name: 'Los Ríos' },
			{ name: 'Manabí' },
			{ name: 'Morona Santiago' },
			{ name: 'Napo' },
			{ name: 'Orellana' },
			{ name: 'Pastaza' },
			{ name: 'Pichincha' },
			{ name: 'Santa Elena' },
			{ name: 'Santo Domingo de los Tsáchilas' },
			{ name: 'Sucumbíos' },
			{ name: 'Tungurahua' },
			{ name: 'Zamora Chinchipe' },
		],
		departmentsChile: [
			{ name: 'Tarapacá' },
			{ name: 'Antofagasta' },
			{ name: 'Antofagasta' },
			{ name: 'Atacama' },
			{ name: 'Coquimbo' },
			{ name: 'Valparaíso' },
			{ name: 'O’Higgins' },
			{ name: 'O’Higgins' },
			{ name: 'Maule' },
			{ name: 'Bío-Bío' },
			{ name: 'La Araucanía' },
			{ name: 'Los Lagos' },
			{ name: 'Aysén' },
			{ name: 'Magallanes' },
			{ name: 'Metropolitana de Santiago' },
			{ name: 'Los Ríos' },
			{ name: 'Arica y Parinacota' },
		],
		departmentsColombia: [
			{ name: 'Amazonas' },
			{ name: 'Antioquia' },
			{ name: 'Arauca' },
			{ name: 'Atlántico' },
			{ name: 'Bolívar' },
			{ name: 'Bolívar' },
			{ name: 'Boyacá' },
			{ name: 'Caldas' },
			{ name: 'Caquetá' },
			{ name: 'Casanare' },
			{ name: 'Cauca' },
			{ name: 'Cesar' },
			{ name: 'Chocó' },
			{ name: 'Córdoba' },
			{ name: 'Cundinamarca' },
			{ name: 'Guainía' },
			{ name: 'Guaviare' },
			{ name: 'Huila' },
			{ name: 'La Guajira' },
			{ name: 'Magdalena' },
			{ name: 'Meta' },
			{ name: 'Nariño' },
			{ name: 'Norte de Santander' },
			{ name: 'Putumayo' },
			{ name: 'Quindío' },
			{ name: 'Risaralda' },
			{ name: 'San Andrés y Providencia' },
			{ name: 'Santander' },
			{ name: 'Sucre' },
			{ name: 'Tolima' },
			{ name: 'Valle del Cauca' },
			{ name: 'Vaupés' },
			{ name: 'Vichada' },
		],
		departmentsBolivia: [
			{ name: 'Beni' },
			{ name: 'Chuquisaca' },
			{ name: 'Cochabamba' },
			{ name: 'La Paz' },
			{ name: 'Oruro' },
			{ name: 'Pando' },
			{ name: 'Potosí' },
			{ name: 'Santa Cruz' },
			{ name: 'Tarija' },
		],
		caption: '',
		showloading: false,
	};
}
export default {
	name: 'form-component',
	data,
	created,
	computed: {
		disabled,
		departments,
		prefixPhone,
	},
	methods: {
		saveInformation,
		clearForm,
		sendInformation,
		showMessage,
		sendInformationWsp,
	},
	props: {
		provinces: {
			type: Array,
			default: () => [],
		},
		footer: {
			type: Boolean,
			default: false,
		},
		cellar: {
			type: Object,
			default: () => [],
		},
		count: [Number, String],
	},
};
</script>
<style lang="scss" scoped>
	.form-component {
		background: color(white);
		box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.08);
		border-radius: 8px;
		margin-left: auto;
		padding-top: 43px;
		max-width: 447px;
		overflow: hidden;
		position: relative;

		@media (max-width: 936px) {
			margin-bottom: 20px;
			max-width: 100%;
			width: 100%;
		}
	}

	.title-form {
		color: color(green-dark);
		font-family: font(lato-regular);
		font-weight: map-get($weight, w800);
		font-size: size(large27);
		text-align: center;

		&.desktop {
			@media (max-width: 936px) {
				display: none;
			}
		}

		&.mobile {
			@media (min-width: 936px) {
				display: none;
			}
		}
	}

	.subtitle-form {
		color: color(form-grey);
		font-family: font(lato-regular);
		font-size: size(medium18);
		text-align: center;
	}

	.input-component {
		border: 1px solid color(input);
		border-radius: 8px;
		height: 40px;
		margin-bottom: 20px;
		padding: 0 15px;
		width: 100%;

		&:focus {
			outline: 0px;
		}

		@media (max-width: 936px) {
			border-radius: 3px;
			height: 50px;
		}
	}

	.btn-form {
		background: color(green-link);
		border-radius: 9px;
		color: color(white);
		font-family: font(lato-regular);
		font-size: size(medium18);
		font-weight: map-get($weight, w900);
		margin-bottom: 36px;
		padding: 10px 35px;
		width: 100%;

		@media (max-width: 936px) {
			margin-top: 14px;
			padding: 14px 35px;
		}
	}

	.font-green {
		color: color(title-green);
	}

	.font11 {
		color: color(form-gray);
		font-family: font(lato-regular);
		font-size: size(medium);
	}

	.contact-form {
		padding: 37px 45px 0px;

		@media (max-width: 936px) {
			padding: 15px 15px 0px;
		}
	}

	.footer-form {
		background: map-get($colors, title-green);
		border-radius: 0 0 8px 8px;
		color: map-get($colors, white);
		padding: 15px 0;

		@media (max-width: 936px) {
			border-radius: 0;
		}
	}

	.wrapper-btn {
		padding: 20px 42px 0px;

		@media (max-width: 936px) {
			padding: 15px 50px 0px;
		}
	}

	.btn-not-available {
		border: 1px solid map-get($colors, title-green);
		border-radius: 2px;
		color: map-get($colors, title-green);
		height: 100%;
		padding: 8px 11px;
		text-align: center;
		width: 100%;
	}

	.btn-available {
		background: map-get($colors, title-green);
		border-radius: 2px;
		color: map-get($colors, white);
		display: block;
		height: 100%;
		padding: 8px 11px;
		text-align: center;
		width: 100%;
	}

	.wrapper-message {
		background: map-get($colors, white);
		bottom: 0;
		border-radius: 9px;
		height: 100%;
		padding-top: 40%;
		position: absolute;
		left: 0;
		right: 0;
		text-align: center;
		top: -100%;
		transition: all 0.5s ease;
		z-index: 1;

		&.open {
			top: 0;
		}
	}

	.message-text {
		color: map-get($colors, title-green);
		font-size: map-get($sizes, large);
	}

	.message-information {
		color: map-get($colors, form-grey);
		font-size: map-get($sizes, medium16);
	}

	.wrapper-loading {
		align-items: center;
		bottom: 0;
		display: flex;
		justify-content: center;
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
	}

	.wrapper-opacity {
		background-color: color(white);
		bottom: 0;
		left: 0;
		opacity: 0.5;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 1;
	}

	.loading {
		position: absolute;
		z-index: 2;
	}

	.center {
		text-align: center;
	}

	.text-warehouse {
		background: color(back-gray-l);
		border: 1px solid color(border-l);
		border-radius: 8px;
		color: color(title-green);
		font-weight: 600;
		margin: auto;
		padding: 10px 0;
		width: 220px;
	}

	.text-info {
		color: color(caption);
    font-size: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/form-component.vue